<template>
  <div class="dict">
    <el-dialog
      :title="'可放货额度单据明细'"
      :visible.sync="dialogVisible"
      :width="'1200px'"
      @close="close"
    >
      <base-form
        v-if="dialogVisible"
        v-model="formData"
        :options="options"
        ref="baseForm"
        :rules="rules"
        @input="handleChange"
        label-width="100px"
      >
      </base-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BaseForm from '@/components/form/base-form';
  import API from '@/api/purchaseSalesCenter/credit/orderLadingLimit.js';
  import BASE_API from '@/api/dataBase';
  import loading from '@/common/js/load.js'; //loading
  export default {
    components: {
      BaseForm,
    },
    name: 'orderLadingLimitEdit',
    data() {
      return {
        defaultVisible: false,
        dialogVisible: false,
        load: false,
        type: false,
        canEdit: true,
        formData: {},
        companyCode: '',
        companyList: [],
        departmentList: [],
        initFlag: true, //查询详情进入页面时，先不执行handleChange
      };
    },
    props: ['dialogData'],
    watch: {
      defaultVisible() {
        if (this.defaultVisible) {
          this.getDetail();
        }
        this.dialogVisible = this.defaultVisible;
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList() {
          let obj = {};
          return obj;
        },
      }),
      currencyList() {
        return this.$baseRequest.getDictListMapByType('all_currency');
      },
      options() {
        // const data = this.formData;
        return [
          {
            type: 'select',
            label: '公司',
            prop: 'orderCompanyCode',
            placeholder: '请选择公司',
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
            required: true,
          },
          {
            type: 'select',
            prop: 'orderDepartmentCode',
            label: '部门',
            placeholder: '请选择部门',
            options: this.departmentList,
            required: true,
          },
          {
            type: 'dict',
            label: '单据类型',
            prop: 'orderType',
            dictType: 'LADING_LIMIT_ORDERTYPE',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            type: 'input',
            label: '单据编号',
            prop: 'orderNo',
            clearable: true,
            placeholder: '请输入单据编号',
            required: true,
          },
          {
            type: 'searchTable',
            prop: 'partnerNo',
            isMultiple: true,
            label: '客户',
            currentValue: this.formData.partnerName,
            extraData: {
              departmentCode: this.formData.departmentCode,
              companyCode: this.userInfo.companyCode,
            },
            required: true,
            searchType: 'customer',
          },
          {
            type: 'select',
            label: '币种',
            prop: 'currencyCode',
            clearable: true,
            disabled: false,
            options: this.currencyList,
            currentValue: this.formData.currencyName,
            name: 'currencyName',
            code: 'currencyCode',
            valueKey: 'value',
            labelKey: 'label',
            valueType: 'object',
            required: true,
          }, //币种
          {
            type: 'amountNumber',
            label: '金额',
            prop: 'amount',
            min: -99999999999999,
            clearable: true,
            required: true,
          },
        ];
      },
      rules() {
        return {};
      },
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      getDetail(query) {
        // this.$refs.baseForm.$refs.ruleForm.reset()
        this.formData.partnerNo = this.dialogData.partnerNo;
        this.formData.partnerName = this.dialogData.partnerName;
        this.formData.currencyCode = this.dialogData.currencyCode;
        console.log(this.formData);
        console.log(query);
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          BASE_API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      // 获取部门
      getdepartmentList(companyCode) {
        this.$axios.post(BASE_API.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
            console.log(this.departmentList);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      refreshData(obj) {
        console.log(obj);
      },
      // // 重置行信息
      resetRowInfo() {
        this.$refs.rowInfo.formData = [];
      },

      handleClick(item) {
        console.log(item);
        switch (item.buttonUrl) {
          case 'save':
            this.save();
            break;
        }
      },
      close() {
        this.defaultVisible = false;
        this.formData = {};
      },
      handleChange(v, prop) {
        if (this.canEdit) {
          this.formData[prop] = v[prop];
          if (prop == 'currencyCode') {
            this.formData.currencyCode = v[prop];
            this.formData.currencyName =
              this.currencyList.find((i) => i.value === v[prop]) &&
              (this.currencyList.find((i) => i.value === v[prop]).label || '');
          } else if (prop == 'orderCompanyCode') {
            this.formData.orderCompanyCode = v[prop];
            if (this.formData.orderCompanyCode == '') {
              this.departmentList = [];
              this.formData.orderDepartmentName = '';
              this.formData.orderDepartmentCode = '';
              return;
            } else {
              this.formData.orderCompanyName =
                this.companyList.find((i) => i.value === v[prop]) &&
                (this.companyList.find((i) => i.value === v[prop]).label || '');
              console.log(this.formData.orderCompanyName);
              this.departmentList = [];
              this.formData.orderDepartmentName = '';
              this.formData.orderDepartmentCode = '';
              this.getdepartmentList(this.formData.orderCompanyCode);
            }
          } else if (prop == 'orderDepartmentCode') {
            this.formData.orderDepartmentName =
              this.departmentList.find((i) => i.value === v[prop]) &&
              (this.departmentList.find((i) => i.value === v[prop]).label || '');
            console.log(this.formData.orderDepartmentName);
          } else if (prop == 'partnerNo') {
            console.log(v[prop]);
            if (v[prop]) {
              let info = v[prop][0];
              console.log(info);
              this.formData.partnerName = info.partnerZhName;
              this.formData.partnerNo = info.partnerCode;
              console.log(this.formData);
            } else {
              this.formData.partnerName = '';
            }
          }
        }
      },
      submit() {
        this.getVal()
          .then(() => {
            console.log('validateInboundSuc');
            loading.startLoading();
            let url = API.SAVE_LADING_LIMIT_DETAIL_API;
            this.$axios
              .post(url, this.formData)
              .then((res) => {
                loading.endLoading();
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.close();
                  this.$emit('confirm');
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              })
              .catch(() => loading.endLoading());
          })
          .catch(() => {
            console.log('validateInbounderr');
            return false;
          });
      },
      // 校验
      getVal() {
        return new Promise((resolve, reject) => {
          this.$refs.baseForm
            .handleSubmit()
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      },
      // 币种格式转换
      fotmatCurrency({ cellValue }) {
        console.log(cellValue);
        if (cellValue) return this.currencyList.find((it) => it.value == cellValue).label;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
</style>
